import { Checkbox, Select } from '@plaidev/sour-react';
import type { ReactElement } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { useColumnEditor } from '../context/ColumnEditorContext';
import type { FormValues } from '../types';

export function ConfigureCustomerUkSection(): ReactElement {
  const { control } = useFormContext<FormValues>();
  const { customerUkEnabled, customerColumnNames } = useColumnEditor();

  return (
    <section className="flex flex-col gap-3 rounded-lg border border-default p-4">
      <h2 className="text-sm font-semibold text-default">一意キー（顧客）</h2>
      <Controller
        control={control}
        name="customerUkEnabled"
        render={({ field }) => (
          <Checkbox
            label="顧客の一意キーを指定する"
            checked={field.value}
            onCheckedChange={(checked) => {
              field.onChange(!!checked);
            }}
          />
        )}
      />
      {customerUkEnabled ? (
        customerColumnNames.length === 0 ? (
          <p className="text-sm text-negative">「顧客」にマップされている列がありません。先に上の表で振り分けを行ってください。</p>
        ) : (
          <Controller
            control={control}
            name="customerUkColumns"
            render={({ field }) => (
              <Select
                multiple
                variant="contained"
                placeholder="顧客の一意キーを選択"
                options={customerColumnNames.map((n) => ({ value: n, label: n }))}
                value={field.value}
                onChange={(v) => field.onChange(Array.isArray(v) ? (v as string[]) : [])}
              />
            )}
          />
        )
      ) : null}
    </section>
  );
}
